<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import firebase from 'firebase/app';


/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Payouts",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
     
      title: "Payouts",
      items: [
        {
          text: "Payouts",
          href: "/payouts",
        },
        {
          text: "Payouts",
          active: true,
        },
      ],
      nPayouts: [],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#ffffff",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      payoutStatus: [
          { value: "Processing", text: "Processing" },
          { value: "Deposited", text: "Deposited" },
      ],
      selectedStatus: "Processing"
    };
  },
  methods: {
    async getAllPayouts(){
        this.nPayouts = [];
      await firebase.firestore().collection("payouts")
      .where("status", "==", this.selectedStatus).get().then((dataList)=>{
        // eslint-disable-next-line no-console
                        // console.log(this.selectedStatus);
        if(dataList.size > 0){
          var itemArray = [];
          dataList.docs.forEach((singleDoc)=>{
            var data = {
              id: singleDoc.id,
              date: singleDoc.data().date,
              bankDetails: singleDoc.data().bankDetails,
              status: singleDoc.data().status,
              depositor: singleDoc.data().depositor,
              userId: singleDoc.data().userId,
              storeId: singleDoc.data().storeId,
              storeName: singleDoc.data().storeName,
              totalDeposited: singleDoc.data().totalDeposited,
              feePercent: singleDoc.data().feePercent,
              deductions: singleDoc.data().deductions,
              transactions: singleDoc.data().transactions,
              email: singleDoc.data().email ?? null
            }
            itemArray.push(data);
            this.nPayouts = itemArray
          })
        }
      })
    }
  },
  mounted() {
    this.getAllPayouts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
        <div class="col-sm-8">
            <b-form-select @change="getAllPayouts()" v-model="selectedStatus" :options="payoutStatus" class="mb-3" />
        </div>
    </div>
    <div v-if="nPayouts" class="row">
      <div v-for="grid in nPayouts" :key="grid.id" class="col-xl-4 col-sm-6">
        <div class="card">
          <div class="card-body">
            <div class="media">
              <div class="media-body overflow-hidden">
                <h5 class="text-truncate font-size-15">
                  <router-link class="text-dark" :to="'/payout-details/?id='+grid.id">
                    {{ grid.storeName }}
                  </router-link>
                </h5>
                <p class="text-muted mb-4">{{ grid.bankDetails.bankName }}</p>
            
              </div>
            </div>
          </div>
          <div class="px-4 py-3 border-top">
            <ul class="list-inline mb-0">
              <li class="list-inline-item me-3">
                <span
                  class="badge bg-warning"
                  >{{ grid.transactions.length }} Transactions</span
                >
              </li>
              <li class="list-inline-item me-3">
                <p class="text-muted mb-4">Bank status: {{ grid.status }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
